/* 报告 */
const ReportPage = r => require.ensure([], () => r(require('./')), 'ReportPage')
// 获取体检报告
const GetReportWarning = r => require.ensure([], () => r(require('./get/warning.vue')), 'GetReport')
const GetReport = r => require.ensure([], () => r(require('./get/')), 'GetReport')
// 个人体检报告列表
const personalReport = r => require.ensure([], () => r(require('./personalReport/'), 'personalReport'))
// 指标解读
const indicatorsParsing = r => require.ensure([], () => r(require('./indicatorsParsing/'), 'indicatorsParsing'))
// 指标解读每一项
const indicatorsItems = r => require.ensure([], () => r(require('./indicatorsItems'), 'indicatorsItems'))
// 专家解读
const expertInterpretation = r => require.ensure([], () => r(require('./expertInterpretation/'), 'expertInterpretation'))
// 个人体检报告
const reportContent = r => require.ensure([], () => r(require('./reportContent'), 'reportContent'))
// 体检报告异常项
const reportAbnormal = r => require.ensure([], () => r(require('./abnormalItems'), 'reportAbnormal'))
// 指标解读手册每一项
const indicatorsItemDetail = r => require.ensure([], () => r(require('./indicatorsItemDetail'), 'indicatorsItemDetail'))
// 报告检索
const SearchReport = r => require.ensure([], () => r(require('@/views/report/search/info-search')), 'SearchReport')
const SearchReportList = r => require.ensure([], () => r(require('@/views/report/search/list')), 'SearchReportList')
const SearchReportContent = r => require.ensure([], () => r(require('@/views/report/search/detail'), 'SearchReportContent'))
// 报告解读
const ReportInterpretation = r => require.ensure([], () => r(require('@/views/report/interpretation')), 'ReportInterpretation')

export default {
  path:'/report',
  component: ReportPage,
  meta: { title: '报告' },
  redirect: '/report/personal',
  children: [{
    path: 'how/:hid',
    name: 'GetReportWarning',
    meta: { title: '如何查看体检报告' },
    component: GetReportWarning
  },{
    path: 'get/:hid',
    name: 'GetReport',
    meta: { title: '领取报告' },
    component: GetReport
  }, {
    path: 'personal',
    name: 'personalReport',
    meta: { title: '体检报告' },
    component: personalReport
  }, {
    path: 'indicatorsParsing',
    name: 'indicatorsParsing',
    meta: { title: '指标解读' },
    component: indicatorsParsing
  }, {
    path: 'indicatorsItems/:itemId',
    name: 'indicatorsItems',
    meta: { title: '指标解读' },
    component: indicatorsItems
  }, {
    path: 'expert-interpretation',
    name: 'expertInterpretation',
    meta: { title: '专家解读' },
    component: expertInterpretation
  }, {
    path: 'content/:reportId',
    name: 'reportContent',
    meta: { title: '体检报告' },
    component: reportContent
  }, {
    path: 'content/:reportId/abnormal',
    name: 'reportAbnormal',
    meta: { title: '异常项' },
    component: reportAbnormal
  }, {
    path: 'indicatorsItemDetail/:itemId/:contentId/:nameId',
    name: 'indicatorsItemDetail',
    meta: { title: '指标解读' },
    component: indicatorsItemDetail
  }, {
    path: 'search',
    name: 'SearchReport',
    meta: { title: '报告检索' },
    component: SearchReport
  }, {
    path: 'search/list',
    name: 'SearchReportList',
    meta: { title: '报告检索' },
    component: SearchReportList
  }, {
    path: 'search/detail',
    name: 'SearchReportDetail',
    meta: { title: '报告检索' },
    component: SearchReportContent
  }, {
    path: 'interpretation',
    name: 'ReportInterpretation',
    meta: { title: '报告解读' },
    component: ReportInterpretation
  }]
}



// WEBPACK FOOTER //
// ./src/views/report/router.js